module.exports = __webpack_public_path__ + "img/logo_zeptoexpress.9975681c.png";